import React from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { isEmpty } from "lodash";
import { Bars as BarSpinner } from "react-loader-spinner";
import { FindInPageRounded } from "@material-ui/icons";

import LayoutTemplate from "../../../components/common/layout-template";
import FilterSection from "./templates/filter-section";
import PageDomain, { WIDGET_TYPE } from "./domain";
import PageContext from "./context";
import StatTable from "./templates/stat-table";
import PackagesBreakDownChart from "./templates/stat-table/packages-breakdown-chart";
import OperatorPackageConversions from "./templates/operator-package-conversions";

import "./style.css";

const WidgetArea = ({ rawApiData, widgetType }) => {
  if (isEmpty(rawApiData)) {
    return (
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className="no-result-view gap-x-8"
      >
        <FindInPageRounded fontSize="medium" />
        <Typography>Submit the form to see results</Typography>
      </Grid>
    );
  }
  if (widgetType === WIDGET_TYPE.default.id) {
    return (
      <Grid container>
        <Grid item container className="w-half">
          <StatTable />
        </Grid>
        <Grid item container className="w-half">
          <PackagesBreakDownChart />
        </Grid>
      </Grid>
    );
  }
  if (widgetType === WIDGET_TYPE.operatorPricingTierConvertions.id) {
    return <OperatorPackageConversions rawDataApi={rawApiData} />;
  }
};

const RealTimeKpiPage = () => {
  const [operators, setOperators] = React.useState([]);
  const [tableDataset, setTableDataset] = React.useState({});
  const [rawApiData, setRawApiData] = React.useState({});
  const [packageBreakdown, setPackageBreakdown] = React.useState({});
  const [widgetType, setWidgetType] = React.useState(
    WIDGET_TYPE.operatorPricingTierConvertions.id,
  );
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [filterValues, setFilterValues] = React.useState({});

  React.useEffect(() => {
    PageDomain.initializePage({ setOperators });
  }, []);

  React.useEffect(() => {
    if (!isEmpty(rawApiData)) {
      PageDomain.generateTableDataset({ rawApiData, setTableDataset });
      PageDomain.generatePackageBreakdown({ rawApiData, setPackageBreakdown });
    }
  }, [rawApiData]);

  return (
    <LayoutTemplate
      mainTitle="Operators"
      subTitle="Real Time KPIs"
      mainCSSIdentifier="real-time-kpi-page-v2"
    >
      <PageContext.Provider
        value={{
          operators,
          setOperators,
          tableDataset,
          setTableDataset,
          setRawApiData,
          packageBreakdown,
          setWidgetType,
          widgetType,
          isSubmitting,
          setIsSubmitting,
          filterValues,
          setFilterValues,
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          className="gap-y-32"
        >
          <FilterSection />
          {isSubmitting ? (
            <Box className="widget-area-loading">
              <BarSpinner
                height="64"
                width="64"
                color="#F9E79F"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
              />
            </Box>
          ) : (
            <WidgetArea rawApiData={rawApiData} widgetType={widgetType} />
          )}
        </Grid>
      </PageContext.Provider>
    </LayoutTemplate>
  );
};

export default RealTimeKpiPage;
